<template>
  <div class="detail">
    <div class="flex-sb-center detail_title">
      <div class="fs-16 fw-600">Documents</div>
      <span>
        <v-button
          gray
          @click="handleEidt">Back</v-button>
        <v-button
          green
          class="mg-l-15"
          @click="showUploadDoc=true">Add File</v-button>
      </span>
    </div>
    <div class="mg-t-20 document-form sme-container__info sme-container__info-document">
      <p
        v-if="file.length<=0"
        class="fs-14 color-dark">No Record</p>
      <template v-else>
        <div class="table table_no_title" >
          <div
            v-for="(item,index) in file"
            :key="'file_'+index"
            class="form-item tr">
            <span class="del-btn">
              <v-button
                red
                @click="handleDel(item)">Delete</v-button></span>
            <file-container
              is-show-detail
              is-renew-type
              is-viewer
              :is-company="isCompany"
              :product-id="productId"
              :fileData="item"
            />
          </div>
        </div>
      </template>
    </div>
    <upload-internal-doc
      v-model="showUploadDoc"
      :class-id="class_id"
      :is-company="isCompany"
      @update="handleUpdate"></upload-internal-doc>
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getEnquiryRemarkList} from '@api/enquiry'
import uploadInternalDoc from './upload-internal-doc'
import {renewFileTypeName} from '@/utils/renew_type'
import {delRenewalReminder} from '@/api/renewal'
export default {
  name: 'renew-ticket-detail',
  components:{
    uploadInternalDoc
  },
  mixins: [MixinOptions],
  props:{
    form:{
      type:Object,
      default:()=>({})
    }
  },
  data(){
    return{
      message:'',
      showUploadDoc:false
    }
  },
  computed:{
    isFina(){
      let {merchant_platform} = this.form||{}
      return merchant_platform==2
    },
    productId(){
      let {order_detail} = this.form||{}
      let {product_id} = order_detail||{}
      return  product_id||''
    },
    relation(){
      let {relation} = this.form||{}
      return relation
    },
    isCompany(){
      let {customer} = this.form||{}
      let {identity} = customer||{}
      return identity==2
    },
    class_id(){
      let {class_id} = this.relation||{}
      return class_id
    },
    file(){
      let {file} = this.relation||{}
      return file||[]
    },
    isMotor(){
      return this.productId == 11
    },
    isCAR(){
      return this.class_id ==79
    },
    isTravelOrPA(){
      let {type_of_insured} = this.form||{}
      return type_of_insured==2&&this.productId==18||[14].includes(this.productId)
    },
    isSme(){
      return this.productId >= 80
    },
    renewFileTypeName(){
      let type_name = renewFileTypeName
      if(this.isCompany)
        type_name.id_type_pic_path = 'Certificate of Incorporation/Business Registration Certificate'
      if(this.isCAR)
        type_name.mpf_files = 'Others / Supporting Doc'
      return type_name
    },
  },
  methods:{
    handleEidt(){
      this.$emit('cancel')
    },
    handleDel({id,type}){
      this.$ConfirmBox({
        isNewConfirm:true,
        width:500,
        title:'Delete Documents',
        confirmBtn:'Confirm',
        isBtnRed:true,
        message: 'Are you sure to Delete this documents?'
      }).then(() => {
        this.network().delRenewalReminder({id,type})
      })
    },
    handleUpdate() {
      this.$emit('update')
    },
    network(){
      return{
        delRenewalReminder: async (params) => {
          let {ticket_id} = this.$route.query
          let {id,type} = params||{}
          const { data } = await delRenewalReminder({
            ticket_id,
            id,
            type_name:this.renewFileTypeName[type]
          })
          this.$emit('update')
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../quoting/sme/info";
.document-table{
  .tr:last-child{
    border-bottom-left-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
  }
}
.tr{
  display: flex!important;
  .del-btn{
    width: 80px;
    margin-right: 15px;
    flex: none;
  }
  /deep/.file-container{
    flex: 1;
  }
}
</style>
